import { useCallback } from 'react';

const useMeasureChangeHandler = (setter, valueAdjuster) =>
  useCallback(
    (event) => {
      const {
        target: { value },
      } = event;
      const valueNumber = Number(value);

      setter(valueAdjuster ? valueAdjuster(valueNumber) : valueNumber);
    },
    [setter, valueAdjuster]
  );

export default useMeasureChangeHandler;
